import type { SVGProps } from "react";
// generated from Cloud.svg — do not edit manually
// prettier-ignore
export default function Cloud(props: SVGProps<SVGSVGElement>) {
  return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}><path d="M 6.5 19 C 4.0147 19 2 16.985 2 14.5 C 2 12.156 3.7915 10.231 6.0797 10.019 C 6.5478 7.172 9.0202 5 12 5 C 14.9798 5 17.4522 7.172 17.9203 10.019 C 20.208 10.231 22 12.156 22 14.5 C 22 16.985 19.9853 19 17.5 19 C 13.1102 19 10.3433 19 6.5 19 Z" stroke="currentColor" strokeWidth="1.5"/></svg>);
}
